module.exports = __webpack_public_path__ + "static/media/b-sci-major-31_LR.2649bc39.jpg";